import React, { useEffect, useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeLightCold,
    themeQuartz
} from 'ag-grid-community';

function TabAbsenKeluarKaryawan({
    absensiKeluar
}) {

    ModuleRegistry.registerModules([AllCommunityModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (absensiKeluar && absensiKeluar.length > 0) {
            const dataTableFilter = absensiKeluar.map(({ ...rest }) => rest);

            setRowData(
                dataTableFilter.map((data) => {
                    const dateParts = data?.checkout_time.split('T')[0].split('-');
                    const year = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const day = Number(dateParts[2]);

                    return {
                        ...data,
                        date: new Date(year, month, day),
                    };
                })
            );
        }
    }, [absensiKeluar]);

    const filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (!cellValue) return -1;

            const cellDate = new Date(cellValue.getFullYear(), cellValue.getMonth(), cellValue.getDate());

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
        minValidYear: 2000,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY",
    };

    const colDefs = [
        {
            field: "date",
            headerName: "Tanggal",
            filter: "agDateColumnFilter",
            filterParams: filterParams,
            sort: 'desc',
            valueFormatter: (params) => {
                const date = params.value;
                if (date instanceof Date && !isNaN(date)) {
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}-${month}-${year}`;
                }
                return '';
            }
        },
        {
            field: "jam",
            headerName: 'Jam',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.checkout_time?.split('T')[1]?.split('.')[0]}
                    </div>
                );
            },
        },
        {
            field: "early_duration",
            headerName: 'Pulang Awal',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.early_duration?.split('.')[0]}
                    </div>
                );
            },
        },
        {
            field: "overtime_duration",
            headerName: 'Lembur',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.overtime_duration?.split('.')[0]}
                    </div>
                );
            },
        },
        {
            field: "checkout_place",
            headerName: 'Lokasi',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.checkout_place}
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const gridRef = useRef(null);

    return (
        <div style={{ height: 500 }}>

            <AgGridReact
                theme={themeLightCold}
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                // pagination={true}
                rowHeight={25}
            />

        </div>

    )
}

export default TabAbsenKeluarKaryawan
